import { actionGenerator, IReduxAction } from '../../../actionGenerator';

export const CHANGE_OFFER_PRICE = 'OFFER :: CHANGE_OFFER_PRICE';

export type TChangeOfferPriceAction = IReduxAction<typeof CHANGE_OFFER_PRICE>;

export const changeOfferPrice = actionGenerator<typeof CHANGE_OFFER_PRICE>(CHANGE_OFFER_PRICE);
